import React from 'react';
import { ProgressBar, Form } from 'react-bootstrap';

import useGlobal from '../../../../store';
import { TheError } from '../../../../shared/responses/TheResult';

const mapState = (store) => {
  return store.modulo.retenciones_masivas.files.upload;
};

const mapActions = (actions) => {
  return actions.modulo.retenciones_masivas.files.upload;
};

const RetencionesMasivasFilesUploadForm = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);

  const { data, progress, busy, error } = state;

  const select = (event) => {
    actions.onChange({
      file: event.target.files[0],
    });
  };

  return (
    <>
      {!!error && <TheError error={error} />}

      <Form>
        <div className="mb-3">
          <Form.File
            id="formcheck-api-custom"
            custom
          >
            <Form.File.Input
              // isValid
              accept=".csv, .txt, .xls, .xlsx"
              onChange={select}
            />
            <Form.File.Label data-browse="Buscar">
              {!data.file?.name ? 'Seleccionar archivo' : data.file?.name}
            </Form.File.Label>
            <Form.Control.Feedback type="valid">{''}</Form.Control.Feedback>
          </Form.File>
        </div>
      </Form>

      <div className="p-3">
        <label>Instrucciones.</label>
        <ul className="list-unstyled">
          <li>
            1.{' '}
            <a
              target="_blank"
              href="/resources/template-retenciones.xlsx"
            >
              Descarga
            </a>{' '}
            el template
          </li>
          <li>2. Sigue la guía de llenado</li>
          <li>3. Sube el archivo</li>
        </ul>
      </div>

      {(busy || progress > 0) && !!data.file && (
        <ProgressBar
          striped
          variant="info"
          label={`${progress}%`}
          now={progress}
        />
      )}
    </>
  );
};

export default RetencionesMasivasFilesUploadForm;
